import update from 'immutability-helper';

import { ActionTypes } from '../constants';
import { ExperiencesByShippingConfigurationState } from '../types/state';
import { RootActionTypes } from '../../../stores/types';

const initialState: ExperiencesByShippingConfigurationState = {};

export default function (state = initialState, action: RootActionTypes) {
  switch (action.type) {
    case ActionTypes.INVALIDATE_SHIPPING_CONFIGURATION_EXPERIENCES:
      return update(state, {
        [action.payload]: {
          $set: {
            status: 'invalidated',
            entities: [],
          },
        },
      });
    default:
      return state;
  }
}
